import React from 'react'
import './about.css'
import ME from '../../assets/me-avatar.png'
import {GiGraduateCap} from 'react-icons/gi'
import {MdWorkHistory} from 'react-icons/md'
import {MdOutlineInterests} from 'react-icons/md'

const About = () => {
  return (
    <section id='about'>
      <h2>Something About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <GiGraduateCap className='about__card-icon'/>
              <h5>Education</h5>
              <small>Master in Data Science and Business Analytics</small>
            </article>

            <article className='about__card'>
              <MdWorkHistory className='about__card-icon'/>
              <h5>Current Job</h5>
              <small>Data Scientist @Kramp Groep B.V.</small>
            </article>

            <article className='about__card'>
              <MdOutlineInterests className='about__card-icon'/>
              <h5>Interests</h5>
              <small>Analytics, Modelling, Data & AI End-to-End Solution</small>
            </article>

          </div>

          <p>
            <strong>🔍 Business Impact Discovery – Data-backed identification of hidden revenue risks and opportunities</strong><br />
          </p>
          <p>
            <strong>📊 Predictive & Diagnostic Modeling – Embedding customer intelligence into business workflows</strong><br />
          </p>
          <p>
            <strong>🧠 AI Knowledge Systems – Democratizing insights through LLM-driven tooling</strong><br />
          </p>
          <p>
            <strong>🔗 Data Infrastructure – Scalable pipelines with cloud-native data architecture powering product experiences</strong><br />
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>

        </div>
      </div>
    </section>
  )
}

export default About